import React, { useEffect, useMemo, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import L from 'leaflet';
import _ from 'underscore';
import { enqueueSnackbar } from 'actions';
import { onUpdateLegend } from 'components/Map/actions/MapActions';
import {
	SetFormState, ResetFields,
	GetDriveTestsCities, GetFailuresFilters, SetSelectedDates,
	GetFailuresFiltersSideCompare, SetSelectedDatesCompare,
	ToggleSummaryDialog, GetSitesIds, ToggleCarriersColorsDialog,
	ToggleCarriersColorsPickerDialog
} from '../actions/FailuresMapActions';
import CompareBox from './components/CompareBox';
import FiltersTop from './components/FiltersTop';
import FiltersTopCompare from './components/FiltersTopCompare';
import FiltersSide from './components/FiltersSide';
import FiltersSideCompare from './components/FiltersSideCompare';
import AdditionalInfo from './components/AdditionalInfo';
import SummaryDialog from './components/Components/SummaryDialog';
import CarriersColorsDialog from './components/Components/CarriersColorsDialog';
import CarriersColorsPickerDialog from './components/Components/CarriersColorsPickerDialog';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const FailuresMap = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));

	// Map
	const selectedDates = useSelector(state => state.failuresMapReducer.selectedDates);
	const maps = useSelector(state => state.mapReducer.maps);
	const formState = useSelector((state) => state.failuresMapReducer.formState);
	const mapOne = maps.filter(item => item.id === 'failures-map')[0];
	const driveTest = useSelector(state => state.failuresMapReducer.driveTest);
	const driveTestScanner = useSelector(state => state.failuresMapReducer.driveTestScanner);
	const scannerRoute = useSelector(state => state.failuresMapReducer.scannerRoute);

	// Map Compare
	const selectedDatesCompare = useSelector(state => state.failuresMapReducer.selectedDatesCompare);
	const mapTwo = maps.filter(item => item.id === 'failures-map-compare')[0];
	const driveTestCompare = useSelector(state => state.failuresMapReducer.driveTestCompare);
	const driveTestScannerCompare = useSelector(state => state.failuresMapReducer.driveTestScannerCompare);
	const scannerRouteCompare = useSelector(state => state.failuresMapReducer.scannerRouteCompare);

	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const userOperator = useSelector(state => state.session.user.operator);

	const summaryDialogVisibility = useSelector((state) => state.failuresMapReducer.summaryDialogVisibility);
	const carriersColorsDialogVisibility = useSelector((state) => state.failuresMapReducer.carriersColorsDialogVisibility);
	const carriersColorsPickerDialogVisibility = useSelector((state) => state.failuresMapReducer.carriersColorsPickerDialogVisibility);
	const currentColorCode = useSelector((state) => state.failuresMapReducer.currentColorCode);

	const _getData = useCallback(() => {
		dispatch(GetFailuresFilters(role));
		dispatch(GetDriveTestsCities(userId, userOperator));
		dispatch(SetSelectedDates([]));
		dispatch(ResetFields());
		// Map Compare
		dispatch(GetFailuresFiltersSideCompare(role));
		// dispatch(GetDriveTestsCitiesCompare(userId, userOperator));
		dispatch(SetSelectedDatesCompare([]));
		dispatch(GetSitesIds());
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const makeDetailsTable = (item) => {
		const table = `<table class="table table-striped">
							<tr>
							<th>Failure Id: </th>
							<td>${item.failureId}</td>
							</tr>
							<tr>
							<th>Failure Type: </th>
							<td>${item.failureType}</td>
							</tr>
							<tr>
							<th>CFN 1 Level: </th>
							<td>${item.cfn1Level}</td>
							</tr>
							<tr>
							<th>CFN 2 Level: </th>
							<td>${item.cfn2Level}</td>
							</tr>
							<tr>
							<th>CFN 3 Level: </th>
							<td>${item.cfn3Level}</td>
							</tr>
							<tr>
							<th>Latitude: </th>
							<td>${item.latitude}</td>
							</tr>
							<tr>
							<th>Longitude: </th>
							<td>${item.longitude}</td>
							</tr>
						</table>`;
		return table;
	};

	const makeDetailsTableKpis = (item) => {
		const table = `<table class="table table-striped">

						<tr>
						<th>Level: </th>
						<td>${item.kpi}</td>
						</tr>

						<tr>
						<th>Latitude: </th>
						<td>${item.latitude}</td>
						</tr>

						<tr>
						<th>Longitude: </th>
						<td>${item.longitude}</td>
						</tr>

					</table>`;

		return table;
	};

	// const _addLayerFailures = (map, data, type, fitBounds) => {
	// 	map.RemoveLayerById(type);
	// 	const markers = [];

	// 	const voiceIconBlocked = L.icon({
	// 		iconUrl: '/images/failuresIcons/eventsvoicecallattempt_o2.png',
	// 		iconSize: [35, 35], // size of the icon
	// 		iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
	// 		popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
	// 	});

	// 	const voiceIconBlockedQoe = L.icon({
	// 		iconUrl: '/images/failuresIcons/eventsvoiceblockcallQoe_o2.png',
	// 		iconSize: [35, 35], // size of the icon
	// 		iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
	// 		popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
	// 	});

	// 	const voiceIconDropped = L.icon({
	// 		iconUrl: '/images/failuresIcons/eventsvoicedropcall_o2.png',
	// 		iconSize: [35, 35], // size of the icon
	// 		iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
	// 		popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
	// 	});

	// 	const voiceIconDroppedQoe = L.icon({
	// 		iconUrl: 'images/failuresIcons/eventsvoicedropcallQoe_o2.png',
	// 		iconSize: [35, 35], // size of the icon
	// 		iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
	// 		popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
	// 	});

	// 	const packetIcondrop = L.icon({
	// 		iconUrl: 'images/failuresIcons/eventspacketdropcall_o2.png',
	// 		iconSize: [35, 35], // size of the icon
	// 		iconAnchor: [16, 35], // point of the icon which will correspond to marker's location
	// 		popupAnchor: [0, -32] // point from which the popup should open relative to the iconAnchor
	// 	});

	// 	if (!_.isEmpty(data)) {
	// 		data.forEach(item => {
	// 			if (type.includes('voice')) {
	// 				if (item.failureType === 'Blocked Call') {
	// 					const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconBlocked });
	// 					markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
	// 				} else if (item.failureType === 'QoE Call Setup Time') {
	// 					const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconBlockedQoe });
	// 					markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
	// 				} else if (item.failureType === 'Dropped Call') {
	// 					const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconDropped });
	// 					markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
	// 				} else {
	// 					const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: voiceIconDroppedQoe });
	// 					markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
	// 				}
	// 			} else {
	// 				const marker = L.marker([item.latitude, item.longitude], { title: item.failureId, icon: packetIcondrop });
	// 				markers.push(marker.bindPopup(`<br>${makeDetailsTable(item)}<br>`, { autoPan: false }));
	// 			}
	// 		});

	// 		const layer = L.layerGroup(markers, { id: type });
	// 		layer.addTo(map.mapContext.map);
	// 		const group = new L.featureGroup(markers);
	// 		if (fitBounds) {
	// 			map.mapContext.map.fitBounds(group.getBounds());
	// 		}
	// 	}
	// };

	const _addLayerKpi = (map, data, legend, fitBounds, layerName) => {
		map.RemoveLayerById(layerName);
		const markers = [];

		if (!_.isEmpty(data)) {
			data.forEach(item => {
				const marker = L.circle([item.latitude, item.longitude], {
					color: item.color,
					fillColor: item.color,
					fillOpacity: 0.8,
					radius: 10
				});
				markers.push(marker.bindPopup(`<br>${makeDetailsTableKpis(item)}<br>`, { autoPan: false }));
			});

			const layer = L.layerGroup(markers, { id: layerName });
			layer.addTo(map.mapContext.map);
			const group = new L.featureGroup(markers);
			if (fitBounds) {
				map.mapContext.map.fitBounds(group.getBounds());
			}
			dispatch(onUpdateLegend({ id: map.mapContext.id, newLegend: legend }));
		}
	};

	const _addLayerKpiScanner = (map, data, legend, fitBounds, layerName) => {
		map.RemoveLayerById(layerName);
		const markers = [];

		if (!_.isEmpty(data)) {
			data.forEach(item => {
				const marker = L.circle([item.latitude, item.longitude], {
					color: item.color,
					fillColor: item.color,
					fillOpacity: 0.8,
					radius: 10
				});
				markers.push(marker.bindPopup(`<br>${makeDetailsTableKpis(item)}<br>`, { autoPan: false }));
			});

			const layer = L.layerGroup(markers, { id: layerName });
			layer.addTo(map.mapContext.map);
			const group = new L.featureGroup(markers);
			if (fitBounds) {
				map.mapContext.map.fitBounds(group.getBounds());
			}
			dispatch(onUpdateLegend({ id: map.mapContext.id, newLegend: legend }));
		}
	};

	const _removeLayerById = (map, id) => {
		map.RemoveLayerById(id);
	};

	useMemo(() => {
		if (mapOne) {
			_removeLayerById(mapOne.control, 'topologyColors');
			_removeLayerById(mapOne.control, 'topologyColorsLabels');
			if (driveTest.driveTestLegend !== undefined) {
				if (driveTest.driveTestLegend.title !== 'none') {
					if (selectedDates.length > 0) {
						if (driveTest.driveTestLegend.title === 'empty') {
							dispatch(enqueueSnackbar({ message: 'No data found for UE', options: { variant: 'warning' } }));
							_addLayerKpi(
								mapOne.control, driveTest.driveTestPoints,
								driveTest.driveTestLegend || '', false,
								'kpis'
							);
						} else if (formState.values.selectedKpiTech === '4g') {
							_addLayerKpi(
								mapOne.control, driveTest.driveTestPoints,
								driveTest.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						} else if (formState.values.selectedKpiTech === '3g') {
							_addLayerKpi(
								mapOne.control, driveTest.driveTestPoints,
								driveTest.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						} else if (formState.values.selectedKpiTech === '2g') {
							_addLayerKpi(
								mapOne.control, driveTest.driveTestPoints,
								driveTest.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						}
					}
				} else {
					_addLayerKpi(
						mapOne.control, driveTest.driveTestPoints,
						driveTest.driveTestLegend || '', false,
						'kpis'
					);
				}
			}
		}
	}, [driveTest]);

	useMemo(() => {
		if (mapOne) {
			_removeLayerById(mapOne.control, 'topologyColors');
			_removeLayerById(mapOne.control, 'topologyColorsLabels');
			if (driveTestScanner.driveTestLegend !== undefined) {
				if (driveTestScanner.driveTestLegend.title !== 'none') {
					if (selectedDates.length > 0 && formState.values.freq4g !== '' && formState.values.top4g !== '') {
						if (driveTestScanner.driveTestLegend.title === 'empty') {
							dispatch(enqueueSnackbar({ message: 'No data found for Scanner', options: { variant: 'warning' } }));
							_addLayerKpiScanner(
								mapOne.control, driveTestScanner.driveTestPoints,
								driveTestScanner.driveTestLegend || '', false,
								'kpis'
							);
						} else if (formState.values.selectedKpiScannerTech === '4g') {
							_addLayerKpiScanner(
								mapOne.control, driveTestScanner.driveTestPoints,
								driveTestScanner.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
							if (driveTestScanner.driveTestLegend !== undefined) {
								if (driveTestScanner.driveTestLegend.title === 'PCI') {
									const _map = mapOne.control.mapContext.map;
									const mapBounds = _map.getBounds();
									const mapBoundsPoints = {
										northEast: mapBounds._northEast,
										southWest: mapBounds._southWest
									};
									if (driveTestScanner.topologyColors.length !== 0) {
										mapOne.control.updateTopologyCarriersColors(driveTestScanner.topologyColors, 'topologyColors');
										mapOne.control.addTopologyLabels(driveTestScanner.topologyColors, 'topologyColorsLabels');
									}
								}
							}
						} else if (formState.values.selectedKpiScannerTech === '3g') {
							_addLayerKpiScanner(
								mapOne.control, driveTestScanner.driveTestPoints,
								driveTestScanner.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
							if (driveTestScanner.driveTestLegend !== undefined) {
								if (driveTestScanner.driveTestLegend.title === 'SC') {
									const _map = mapOne.control.mapContext.map;
									const mapBounds = _map.getBounds();
									const mapBoundsPoints = {
										northEast: mapBounds._northEast,
										southWest: mapBounds._southWest
									};
									if (driveTestScanner.topologyColors.length !== 0) {
										mapOne.control.updateTopologyCarriersColors(driveTestScanner.topologyColors, 'topologyColors');
										mapOne.control.addTopologyLabels(driveTestScanner.topologyColors, 'topologyColorsLabels');
									}
								}
							}
						} else if (formState.values.selectedKpiScannerTech === '2g') {
							_addLayerKpiScanner(
								mapOne.control, driveTestScanner.driveTestPoints,
								driveTestScanner.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						}
					}
				} else {
					_addLayerKpiScanner(
						mapOne.control, driveTestScanner.driveTestPoints,
						driveTestScanner.driveTestLegend || '', false,
						'kpis'
					);
				}
			}
		}
	}, [driveTestScanner]);

	useMemo(() => {
		if (mapOne) {
			_addLayerKpiScanner(
				mapOne.control, scannerRoute.driveTestPoints,
				scannerRoute.driveTestLegend || '', formState.values.mapAutoZoom,
				'scannerRoute'
			);
		}
	}, [scannerRoute]);

	useMemo(() => {
		if (mapTwo) {
			_removeLayerById(mapTwo.control, 'topologyColors');
			if (driveTestCompare.driveTestLegend !== undefined) {
				if (driveTestCompare.driveTestLegend.title !== 'none') {
					if (selectedDatesCompare.length > 0) {
						if (driveTestCompare.driveTestLegend.title === 'empty') {
							dispatch(enqueueSnackbar({ message: 'No data found for UE', options: { variant: 'warning' } }));
							_addLayerKpi(
								mapTwo.control, driveTestCompare.driveTestPoints,
								driveTestCompare.driveTestLegend || '', false,
								'kpis'
							);
						} else if (formState.values.selectedKpiTechCompare === '4g') {
							_addLayerKpi(
								mapTwo.control, driveTestCompare.driveTestPoints,
								driveTestCompare.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						} else if (formState.values.selectedKpiTechCompare === '3g') {
							_addLayerKpi(
								mapTwo.control, driveTestCompare.driveTestPoints,
								driveTestCompare.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						} else if (formState.values.selectedKpiTechCompare === '2g') {
							_addLayerKpi(
								mapTwo.control, driveTestCompare.driveTestPoints,
								driveTestCompare.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						}
					}
				} else {
					_addLayerKpi(
						mapTwo.control, driveTestCompare.driveTestPoints,
						driveTestCompare.driveTestLegend || '', false,
						'kpis'
					);
				}
			}
		}
	}, [driveTestCompare]);

	useMemo(() => {
		if (mapTwo) {
			_removeLayerById(mapTwo.control, 'topologyColors');
			if (driveTestScannerCompare.driveTestLegend !== undefined) {
				if (driveTestScannerCompare.driveTestLegend.title !== 'none') {
					if (selectedDatesCompare.length > 0 && formState.values.freq4gCompare !== '' && formState.values.top4gCompare !== '') {
						if (driveTestScannerCompare.driveTestLegend.title === 'empty') {
							dispatch(enqueueSnackbar({ message: 'No data found for Scanner', options: { variant: 'warning' } }));
							_addLayerKpiScanner(
								mapTwo.control, driveTestScannerCompare.driveTestPoints,
								driveTestScannerCompare.driveTestLegend || '', false,
								'kpis'
							);
						} else if (formState.values.selectedKpiScannerTechCompare === '4g') {
							_addLayerKpiScanner(
								mapTwo.control, driveTestScannerCompare.driveTestPoints,
								driveTestScannerCompare.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
							if (driveTestScannerCompare.driveTestLegend.title === 'PCI') {
								const _map = mapTwo.control.mapContext.map;
								const mapBounds = _map.getBounds();
								const mapBoundsPoints = {
									northEast: mapBounds._northEast,
									southWest: mapBounds._southWest
								};
								mapTwo.control.updateTopologyCarriersColors(driveTestScannerCompare.topologyColors, 'topologyColors');
							}
						} else if (formState.values.selectedKpiScannerTechCompare === '3g') {
							_addLayerKpiScanner(
								mapTwo.control, driveTestScannerCompare.driveTestPoints,
								driveTestScannerCompare.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
							if (driveTestScannerCompare.driveTestLegend.title === 'PCI') {
								const _map = mapTwo.control.mapContext.map;
								const mapBounds = _map.getBounds();
								const mapBoundsPoints = {
									northEast: mapBounds._northEast,
									southWest: mapBounds._southWest
								};
								mapTwo.control.updateTopologyCarriersColors(driveTestScannerCompare.topologyColors, 'topologyColors');
							}
						} else if (formState.values.selectedKpiScannerTechCompare === '2g') {
							_addLayerKpiScanner(
								mapTwo.control, driveTestScannerCompare.driveTestPoints,
								driveTestScannerCompare.driveTestLegend || '', formState.values.mapAutoZoom,
								'kpis'
							);
						}
					}
				} else {
					_addLayerKpiScanner(
						mapTwo.control, driveTestScannerCompare.driveTestPoints,
						driveTestScannerCompare.driveTestLegend || '', false,
						'kpis'
					);
				}
			}
		}
	}, [driveTestScannerCompare]);

	useMemo(() => {
		if (mapTwo) {
			_addLayerKpiScanner(
				mapTwo.control, scannerRouteCompare.driveTestPoints,
				scannerRouteCompare.driveTestLegend || '', formState.values.mapAutoZoom,
				'scannerRoute'
			);
		}
	}, [scannerRouteCompare]);

	useEffect(() => {
		if (mapOne) {
			mapOne.control.mapContext.map.invalidateSize();
			mapTwo.control.mapContext.map.invalidateSize();
			mapOne.control.mapContext.map.sync(mapTwo.control.mapContext.map);
			mapTwo.control.mapContext.map.sync(mapOne.control.mapContext.map);
		}
	}, [formState.values.mapCompare, formState.values.mapFilters]);

	const _summaryDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleSummaryDialog(false));
		}
	};

	const _carriersColorsDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleCarriersColorsDialog(false));
		}
	};

	const _carriersColorsPickerDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleCarriersColorsPickerDialog(false));
			dispatch(ToggleCarriersColorsDialog(true));
		}
	};

	// console.log(formState.values.selectedKpiTech);
	// console.log(formState.values.selectedKpiScannerTech);

	let data;
	if (formState.values.selectedKpiTech !== undefined || formState.values.selectedKpiScannerTech !== undefined) {
		if (formState.values.selectedKpiTech !== undefined) {
			data = driveTest.chartData;
		} else if (formState.values.selectedKpiScannerTech !== undefined) {
			data = driveTestScanner.chartData;
		}
	}

	// console.log(formState.values.selectedKpiTechCompare);
	// console.log(formState.values.selectedKpiScannerTechCompare);

	let dataCompare;
	if (formState.values.selectedKpiTechCompare !== undefined || formState.values.selectedKpiScannerTechCompare !== undefined) {
		if (formState.values.selectedKpiTechCompare !== undefined) {
			dataCompare = driveTestCompare.chartData;
		} else if (formState.values.selectedKpiScannerTechCompare !== undefined) {
			dataCompare = driveTestScannerCompare.chartData;
		}
	}

	return (
		<Page className={classes.root} title="Map">
			{/* <Header module="Modules" view="Map" /> */}
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						<Grid container spacing={1}>
							<Grid item md={12} xs={12}>
								<CompareBox />
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid item md={formState.values.mapCompare ? 6 : 12}>
								<FiltersTop mapCompare={formState.values.mapCompare} />
							</Grid>
							<Grid item md={6} xs={6} hidden={!formState.values.mapCompare}>
								<FiltersTopCompare mapCompare={formState.values.mapCompare} />
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid item md={2} xs={2} hidden={!formState.values.mapFilters}>
								<FiltersSide height="68vh" />
							</Grid>
							<Grid item md={formState.values.mapSize}>
								<Map id="failures-map" scale height="68vh" />
							</Grid>

							<Grid md={formState.values.mapSize} hidden={!formState.values.mapCompare}>
								<Map id="failures-map-compare" scale height="68vh" />
							</Grid>
							<Grid item md={2} hidden={!formState.values.mapCompare || !formState.values.mapFilters}>
								<FiltersSideCompare height="68vh" />
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid item md={12} xs={12}>
								<AdditionalInfo data={data} dataCompare={dataCompare} />
							</Grid>
						</Grid>
					</CardContent>
				</Card>
				{summaryDialogVisibility && (
					<SummaryDialog
						onClose={_summaryDialogClose}
						open={summaryDialogVisibility}
					/>
				)}
				{carriersColorsDialogVisibility && (
					<CarriersColorsDialog
						onClose={_carriersColorsDialogClose}
						open={carriersColorsDialogVisibility}
					/>
				)}
				{carriersColorsPickerDialogVisibility && (
					<CarriersColorsPickerDialog
						onClose={_carriersColorsPickerDialogClose}
						open={carriersColorsPickerDialogVisibility}
						currentColorCode={currentColorCode}
					/>
				)}
			</div>
		</Page>
	);
};

export default FailuresMap;
